<template>
	<v-container fluid class="crm-index">
		<div class="d-flex align-center justify-end mb-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.companies.companyUnarchiveValuesCount"
				:loading-info="$store.state.companies.companyUnarchiveValuesLoading"
			/>
		</div>
		<v-data-table
			ref="table"
			:headers="headers"
      :items="$store.state.companies.companyUnarchiveValues"
			item-key="id"
      :loading="$store.state.companies.companyUnarchiveValuesLoading"
			:server-items-length="$store.state.companies.companyUnarchiveValuesCount"
			:options.sync="options"
			loading-text="Cargando datos..."
			class="crm-table"
			:class="$vuetify.breakpoint.mobile ? '':'resizable'"
			disable-sort
			hide-default-footer
			@click:row="selectRow"
			:item-class="selectedRowClass"
			:footer-props="{
        itemsPerPageText: 'Filas por página',
				'items-per-page-options': itemsPerPageOptions
			}"
		>
      <template v-slot:item.name="{ item }">
				<div class="d-flex align-center">
					<p class="ml-2 mb-0">{{ item.name }}</p>
				</div>
      </template>
      <template v-slot:item.value="{ item }">
				<div class="d-flex align-center">
					<p class="ml-2 mb-0">${{ item.value | toThousandFilter }}</p>
				</div>
      </template>
      <template v-slot:item.actions="{ item }">
				<v-tooltip bottom v-if="$store.state.user.userInfo">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="warning"
							class="mx-1"
							@click.stop="() => { selectRow(item); editUnarchiveValue(item); }"
							v-bind="attrs"
							v-on="on"
							v-if="$checkPermissions(['edit_company'])"
						>
							<v-icon small dark>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span>Editar</span>
				</v-tooltip>
				<v-tooltip bottom v-if="$store.state.user.userInfo">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
											icon
							dark
							x-small
							color="error"
							class="mx-1"
							v-if="$checkPermissions(['delete_company'])"
							@click.stop="() => { selectRow(item); deleteUnarchiveValue(item.id); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-delete-outline</v-icon>
						</v-btn>
					</template>
					<span>Eliminar</span>
				</v-tooltip>
      </template>
    </v-data-table>
		<div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.companies.companyUnarchiveValuesCount"
				:loading-info="$store.state.companies.companyUnarchiveValuesLoading"
			/>
		</div>
  </v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import {deleteCompanyUnarchiveValue} from '@/helpers/api/company'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'CompanyUnarchiveValues',
	components: {
		DataTablePagination
	},
  data() {
    return {
      search: '',
			selectedRowItem: null,
			searchInput: null,
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [],
      },
      headers: [
        { text: 'Nombre / Descripción', value: 'name' },
        { text: 'Valor', value: 'value' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
  },
	mounted(){
		const selectedRow = JSON.parse(localStorage.getItem('selected_company_unarchive_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
		this.reloadInfo()
	},
  methods: {
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_company_unarchive_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.reloadInfo()
		},
		reloadInfo(){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('companies/getCompanyUnarchiveValues', data)
		},
		showDeleteCompany(company){
			if(this.$store.state.user.userInfo){
				return company.company.responsible == this.$store.state.user.userInfo.id
			}
			return false
		},
    editUnarchiveValue(value) {
			const data = {
				company_unarchive_value_id: value.id,
				name: value.name,
				value: value.value,
				currency_id: value.currency_id
			}
			this.$store.commit('companies/setCompanyUnarchiveValueModalEditing', data)
			this.$store.commit('companies/setNewUnarchiveValueModal', true)
    },
    async deleteUnarchiveValue(company_unarchive_value_id) {
      await deleteCompanyUnarchiveValue({company_unarchive_value_id})
			this.reloadInfo()
    }
  },
};
</script>

<style scoped>
</style>